module.exports = __webpack_public_path__ + "static/media/Safe-T24.0a893cd5.jpg";